import React, { useEffect, useRef, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addDays, format } from "date-fns";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import { Button, DatePicker, Modal, Pagination, Spin } from "antd";
import { getValue, getDate } from "../../../services/functions";
import { Message, ViewInput } from "../../../GlobalStyles";
import html2pdf from "html2pdf.js";

export default function FinanceiroAdmin({ type }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const reportRef = useRef();
  const [loading, setLoading] = useState(true);
  const [loadingRelatorio, setLoadingRelatorio] = useState(false);
  const [user, setUser] = useState({});
  const [orders, setOrders] = useState([]);
  const [ordersRelatorio, setOrdersRelatorio] = useState([]);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [totalServices, setTotalServices] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());

  const [visibleModalServices, setVisibleModalServices] = useState(false);
  const [currentOrder, setCurrentOrder] = useState({});

  useEffect(() => {
    if (user) {
      loadingOSs();
    }
  }, [user, startDate, endDate, page]);

  useEffect(() => {
    loadingUser();
  }, []);

  async function loadingUser() {
    await api
      .get(`/${type}/${id}`)
      .then((response) => {
        setUser(response.data);
        loadingOSs(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
        navigate(-1);
      });
  }

  async function loadingOSs() {
    setLoading(true);
    user.type = type == "user" ? "cliente" : "tecnico";
    await api
      .get(
        `/orders/${user.type}?id=${id}&page=${page}&startDate=${startDate}&endDate=${endDate}&finance=true`,
      )
      .then((response) => {
        setTotalValue(
          type == "user"
            ? response.data.totalValue
            : response.data.totalValueComission,
        );
        setTotalServices(response.data.totalServices);
        setOrders(response.data.orders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function loadingAllOSs() {
    setLoadingRelatorio(true);
    user.type = type == "user" ? "cliente" : "tecnico";
    await api
      .get(
        `/orders/${user.type}?id=${id}&startDate=${startDate}&endDate=${endDate}&finance=true`,
      )
      .then((response) => {
        setOrdersRelatorio(response.data.orders);
        setTimeout(() => {
          handleGenerateReport();
        }, 100);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoadingRelatorio(false);
  }

  const handleGenerateReport = () => {
    const element = reportRef.current;
    const options = {
      margin: 10,
      filename: `relatorio-financeiro-${user.name}-${format(
        new Date(),
        "dd-MM-yyyy",
      )}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, logging: false },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "css" },
    };

    html2pdf().set(options).from(element).save();
  };

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Finanças {user.name}</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
            width: 150,
            marginRight: 20,
          }}
          onClick={
            loadingAllOSs //handleGenerateReport
          }
          loading={loadingRelatorio}
          disabled={!orders.length}
        >
          Gerar Relátorio
        </Button>
      </div>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <div className="filters-row">
            <ViewInput style={{ width: "100%", maxWidth: 380 }}>
              <p>Selecione o Periodo</p>
              <DatePicker.RangePicker
                placeholder={["data inicial", "data final"]}
                value={[
                  startDate ? dayjs(startDate) : "",
                  endDate ? dayjs(endDate) : "",
                ]}
                locale={locale}
                format={"DD/MM/YYYY"}
                onChange={(value, dateString) => {
                  setStartDate(getDate(dateString[0]));
                  setEndDate(getDate(dateString[1]));
                  setPage(0);
                }}
                allowClear={false}
                onOk={() => {}}
              />
            </ViewInput>
          </div>
          {!!ordersTotal && (
            <>
              <p className="resumo">
                <strong>{ordersTotal}</strong> OSs e{" "}
                <strong>{totalServices}</strong> serviços{" "}
                {type == "user" ? "solicitados" : "realizados"}
              </p>

              <p className="resumo" style={{ marginTop: 10 }}>
                <strong>{getValue(totalValue || 0)}</strong> total
              </p>
              {user.type == "cliente" && (
                <p
                  className="resumo"
                  style={{ marginTop: 5, marginBottom: 10 }}
                >
                  <strong>{getValue(totalValue * 3 || 0)}</strong> média de
                  faturamento
                </p>
              )}
            </>
          )}
          <div className="orders" style={{ marginTop: 5, marginTop: 10 }}>
            {!ordersTotal && (
              <Message>Nenhuma OS finalizada nesse periodo</Message>
            )}
            {orders.map((item) => {
              return (
                <div className="order">
                  <p className="title">
                    <a
                      className="link"
                      onClick={() => {
                        navigate("/admin/os/" + item.id);
                      }}
                    >
                      {item.name
                        ? item.name + " - " + ("00000" + item.id).slice(-5)
                        : ("00000" + item.id).slice(-5)}
                    </a>
                  </p>
                  <div
                    className="backGreen"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setCurrentOrder(item);
                      setVisibleModalServices(true);
                    }}
                  >
                    {item.totalServices} serviços solicitados
                  </div>
                  <div className="row">
                    <div className="back">
                      Finalizado em{" "}
                      {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                    </div>
                    <div className="back">
                      <strong>
                        {getValue(
                          type == "user"
                            ? item.totalValue
                            : item.totalValueComission || 0,
                        )}
                      </strong>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {!!ordersTotal && (
            <Pagination
              style={{
                margin: "25px 0",
                alignSelf: "center",
              }}
              defaultCurrent={page + 1}
              pageSize={30}
              onChange={(page) => {
                setPage(page - 1);
              }}
              total={ordersTotal}
            />
          )}
        </>
      )}
      <Modal
        title={`Serviços da OS #${currentOrder.id}`}
        open={visibleModalServices}
        onCancel={() => setVisibleModalServices(false)}
        footer={[
          <Button key="close" onClick={() => setVisibleModalServices(false)}>
            Fechar
          </Button>,
        ]}
        width={600}
      >
        <div style={{ marginTop: 20 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "bold",
              marginBottom: 10,
              paddingBottom: 5,
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <span style={{ flex: 2 }}>Serviço</span>
            <span style={{ flex: 1, textAlign: "center" }}>Qtd</span>
            <span style={{ flex: 1, textAlign: "right" }}>
              {type === "user" ? "Valor" : "Comissão"}
            </span>
          </div>
          {currentOrder?.items?.map((service, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 8,
                paddingBottom: 8,
                borderBottom: "1px solid #f9f9f9",
              }}
            >
              <span style={{ flex: 2 }}>{service.name}</span>
              <span style={{ flex: 1, textAlign: "center" }}>
                {service.amount}
              </span>
              <span style={{ flex: 1, textAlign: "right" }}>
                {getValue(
                  type === "user" ? service.value : service.commission || 0,
                )}
              </span>
            </div>
          ))}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 15,
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            <span>Total</span>
            <span>
              {getValue(
                type === "user"
                  ? currentOrder.totalValue || 0
                  : currentOrder.totalValueComission || 0,
              )}
            </span>
          </div>
        </div>
      </Modal>

      {/* Relatório oculto para geração de PDF */}
      <div
        style={{
          position: "absolute",
          left: "-9999px",
          top: "0",
          width: "100%",
        }}
      >
        <div
          ref={reportRef}
          style={{
            padding: "20px",
            color: "#000",
            backgroundColor: "#fff",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <div
            style={{
              textAlign: "center",
              borderBottom: "2px solid #008037",
              paddingBottom: "10px",
              marginBottom: "20px",
            }}
          >
            <h1 style={{ color: "#008037", margin: 0 }}>
              Relatório Financeiro
            </h1>
            <p style={{ margin: "5px 0" }}>
              <strong>Usuário:</strong> {user.name}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Período:</strong>{" "}
              {format(new Date(startDate), "dd/MM/yyyy")} a{" "}
              {format(new Date(endDate), "dd/MM/yyyy")}
            </p>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <p>
              <strong>Total de OSs:</strong> {ordersTotal}
            </p>
            <p>
              <strong>Total de Serviços:</strong> {totalServices}
            </p>
            <p>
              <strong>Valor Total:</strong> {getValue(totalValue || 0)}
            </p>
          </div>

          <div className="report-orders">
            {ordersRelatorio.map((item) => (
              <div
                key={item.id}
                className="pdf-os-card"
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  marginBottom: "20px",
                  breakInside: "avoid",
                  pageBreakInside: "avoid",
                  display: "block",
                  overflow: "hidden",
                  backgroundColor: "#fff",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#008037",
                    color: "#fff",
                    padding: "10px 15px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontWeight: "bold", fontSize: "13px" }}>
                    OS #{("0000" + item.id).slice(-4)} - {item.name || ""}
                  </div>
                  <div style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {getValue(
                      type === "user"
                        ? item.totalValue
                        : item.totalValueComission || 0,
                    )}
                  </div>
                </div>

                <div style={{ padding: "10px 15px" }}>
                  <div
                    style={{
                      fontSize: "10px",
                      color: "#666",
                      marginBottom: "10px",
                      borderBottom: "1px solid #f0f0f0",
                      paddingBottom: "5px",
                    }}
                  >
                    Finalizada em:{" "}
                    {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")} |{" "}
                    {item.totalServices} serviços
                  </div>

                  {item.items?.map((service, sIndex) => (
                    <div
                      key={sIndex}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "4px 0",
                        fontSize: "10px",
                        borderBottom:
                          sIndex === item.items.length - 1
                            ? "none"
                            : "1px dashed #eee",
                      }}
                    >
                      <div style={{ flex: 3 }}>{service.name}</div>
                      <div
                        style={{
                          flex: 1,
                          textAlign: "center",
                          color: "#888",
                        }}
                      >
                        {service.amount}x
                      </div>
                      <div
                        style={{
                          flex: 1,
                          textAlign: "right",
                          fontWeight: "500",
                        }}
                      >
                        {getValue(
                          type === "user"
                            ? service.value
                            : service.commission || 0,
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div
            style={{ textAlign: "right", marginTop: "20px", fontSize: "10px" }}
          >
            <p>Relatório gerado em {format(new Date(), "dd/MM/yyyy HH:mm")}</p>
          </div>
        </div>
      </div>
    </Container>
  );
}
